import React, { useState } from "react";

import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";

type Props = {
  title: string;
  warning?: string;
  desc?: string;
  children: any;
  closeWizard?: any;
};

const Wizard = (props: Props) => {
  const [wizardOpen, setWizardOpen] = useState(false);

  const closeWizard = (e: React.MouseEvent<HTMLElement>) => {
    props.closeWizard();
    e.stopPropagation();
  };
  return (
    <div className="wizard center">
      <div className="wizard-header">
        <div className="title">{props.title}</div>
        <div className="wizard-close" onClick={closeWizard}>
          <CloseIcon />
        </div>
      </div>
      <div className="wizard-body">
        <div className="desc">{props.children}</div>
      </div>
      <div className="wizard-footer">
        <div className="wizard-actions">
          <button className="wizard-button back btn " onClick={closeWizard}>
            Back
          </button>
          <button
            className="wizard-button confirm btn green"
            onClick={closeWizard}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Wizard;
